import Axios from '../../../utils/axios'
import axios from 'axios'
import { headers } from '../../../utils/token'
import moment from 'moment'

export const loadInquiryDb = (data) => dispatch => {
  return Axios.get('/faq-feedbacks', dispatch, 'GET_INQUIRY_DB_DATA', { headers: headers })
}
